module.exports = __webpack_public_path__ + "73d106439afe38c5363dcf8d5833cdfc.png";